class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = null;
    this.footer = null;
    this.content = null;
    this.anchorInView = true;
    this.footerInView = false;
    this.anchorObserver = null;
    this.footerObserver = null;
    this.mobileQuery = window.matchMedia('(max-width: 749px)');
    this.handleViewportChange = () => this.#updateDisplay();
    this.handleFormatEdit = (event) => {
      if (!event.target.closest('[data-bep-edit-format]')) return;
      const picker = this.form?.querySelector('variant-picker');
      if (!picker) return;
      picker.scrollIntoView({ block: 'center', behavior: 'auto' });
      picker.querySelector('input:checked, select, input[type="radio"]')?.focus({ preventScroll: true });
    };
  }

  connectedCallback() {
    this.form = this.closest('[data-ref="product-form"]');
    this.footer = document.querySelector('[data-ref="footer"]');
    this.content = this.querySelector('.sticky-add-to-cart__content');

    if (!this.form || !this.content) return;
    this.addEventListener('click', this.handleFormatEdit);

    // Réserve l'espace du sticky dans le flux pour éviter le changement de
    // hauteur du document quand le contenu passe en position: fixed. Sans cela,
    // le contenu sort du flux → la page raccourcit → le footer remonte dans le
    // viewport → le sticky se désactive → boucle infinie de clignotement.
    requestAnimationFrame(() => {
      this.style.minHeight = `${this.offsetHeight}px`;
      this.#initObservers();
      this.mobileQuery.addEventListener('change', this.handleViewportChange);
    });
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleFormatEdit);
    this.anchorObserver?.disconnect();
    this.footerObserver?.disconnect();
    this.mobileQuery.removeEventListener('change', this.handleViewportChange);
    clearTimeout(this.closingTimeout);
  }

  #initObservers() {
    // Le composant lui-même sert d'ancre à l'emplacement réel du CTA.
    // Observer tout le formulaire désactivait le sticky dès qu'un sélecteur de
    // variante entrait dans le viewport, alors que le bouton restait invisible.
    this.anchorObserver = new IntersectionObserver(([entry]) => {
      this.anchorInView = entry.isIntersecting;
      this.#updateDisplay();
    }, { threshold: 0.01 });

    this.anchorObserver.observe(this);

    if (!this.footer) return;

    this.footerObserver = new IntersectionObserver(([entry]) => {
      this.footerInView = entry.isIntersecting;
      this.#updateDisplay();
    });

    this.footerObserver.observe(this.footer);
  }

  #updateDisplay() {
    const shouldBeActive = this.mobileQuery.matches && !this.anchorInView && !this.footerInView;
    const isActive = this.dataset.active === 'true';

    if (shouldBeActive === isActive) return;

    clearTimeout(this.closingTimeout);

    if (shouldBeActive) {
      delete this.dataset.closing;
      this.dataset.active = 'true';
      this.content.classList.add('color-scheme-1');
      return;
    }

    this.dataset.active = 'false';
    this.dataset.closing = 'true';

    this.closingTimeout = setTimeout(() => {
      delete this.dataset.closing;
      this.content.classList.remove('color-scheme-1');
    }, 300);
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
